import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'html-builder',
	template: ``,
	styles: [],
})
export class HtmlBuilderComponent implements OnInit {
	constructor() {}

	ngOnInit(): void {}
}
